import { RPCDocs } from "../../services/rpc.js";
import { IoSend } from "react-icons/io5";
import { MdDeleteForever, MdEdit, MdInbox } from "react-icons/md";
// src/modules/Mail/constants.ts
var Folder = RPCDocs.Mail.GetMessagesList.v1.Folder;
var OPEN_MAIL_URL_KEY = "open_mail_id";
var MAIL_FOLDERS = {
	INBOX: Folder.Inbox.toString(),
	SENT: Folder.Sent.toString(),
	TRASH: Folder.Trash.toString()
};
var MAIL_VIEWS = {
	INBOX: MAIL_FOLDERS.INBOX,
	NEW: "new",
	OPEN: "open",
	SENT: MAIL_FOLDERS.SENT,
	TRASH: MAIL_FOLDERS.TRASH
};
var MAIL_TABS = [
	{
		icon: MdEdit,
		id: MAIL_VIEWS.NEW,
		name: "New"
	},
	{
		icon: MdInbox,
		id: MAIL_VIEWS.INBOX,
		name: "Inbox"
	},
	{
		icon: IoSend,
		id: MAIL_VIEWS.SENT,
		name: "Sent"
	},
	{
		icon: MdDeleteForever,
		id: MAIL_VIEWS.TRASH,
		name: "Trash"
	}
];
export { MAIL_FOLDERS, MAIL_TABS, MAIL_VIEWS, OPEN_MAIL_URL_KEY };

//# sourceMappingURL=constants.js.map